import { render, staticRenderFns } from "./CardEndStageAction.vue?vue&type=template&id=deda79b8"
import script from "./CardEndStageAction.vue?vue&type=script&lang=js"
export * from "./CardEndStageAction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports